import images from './images';

const wines = [
  {
    title: 'Cabernet Sauvignon',
    price: '$89',
    tags: 'FR | Bottle',
  },
  {
    title: 'Gicati Chiaretto',
    price: '$128',
    tags: 'NZ | Bottle',
  },
  {
    title: 'Tourgrevry Cava',
    price: '$68',
    tags: 'SZ | 750 ml',
  },
  {
    title: 'zampenne Branco',
    price: '$46',
    tags: 'US | 750 ml',
  },
  {
    title: 'Cunce Classic',
    price: '$56',
    tags: 'GB | 750 ml',
  },
];

const cocktails = [
  {
    title: 'The Gory Gin',
    price: '$20',
    tags: 'Gin | Naked Juice | honey | 30 ml',
  },
  {
    title: "Frozen Hell",
    price: '$26',
    tags: 'Whiskey | Cream Soda | Pineapple liqueur',
  },
  {
    title: 'The Black Russian',
    price: '$21',
    tags: 'Vodka | Coffee liqueur | Sugar',
  },
  {
    title: 'Salty Dog',
    price: '$29',
    tags: 'Rum | Cane sugar | Lime Bitters',
  },
  {
    title: 'Raspberry Martini',
    price: '$38',
    tags: 'Vodka | Ginger Ale | Fresh raspberries',
  },
];

const awards = [
  {
    imgUrl: images.award,
    title: 'G. Ramsey Prestige',
    subtitle: 'Awarded to the restaurant that best combines snoberry and excellence.',
  },
  {
    imgUrl: images.award,
    title: 'Hottest Plate',
    subtitle: 'In recognition of having the finest clientele in the business.',
  },
  {
    imgUrl: images.award,
    title: 'Galaxy of Excellence',
    subtitle: 'Recognized for most desired dinner spot in the western galaxy',
  },
  {
    imgUrl: images.award,
    title: 'Plating Gods',
    subtitle: 'Elite plating for 9 years in a row.',
  },
];

export default { wines, cocktails, awards };